import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';

export const COLUMNS = (t) => [
    {
        label: t('search.overview.gscAnonymized.columns.domain'),
        key: 'domain',
        data: 'domain',
        Component: Cell,
    },
    {
        label: t('search.overview.gscAnonymized.columns.type'),
        key: 'type',
        data: 'type',
        Component: Cell,
    },
    {
        label: t('search.overview.gscAnonymized.columns.clicks'),
        key: 'clicks',
        data: 'clicks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return numeral(data).format('0.0a');
        },
    },
    {
        label: t('search.overview.gscAnonymized.columns.percent'),
        key: 'percent',
        data: 'percent',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return numeral(data).format('0.00%');
        },
    },
];
